import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '../icon';
import { ExpandButtonComponent } from './expand-button.component';

@NgModule({
  imports: [
    CommonModule,
    IconModule
  ],
  declarations: [
    ExpandButtonComponent
  ],
  exports: [
    ExpandButtonComponent
  ]
})
export class ExpandButtonModule {
}
